export const PLACEHOLDER_PROVINCE = 'Select a province';
export const PLACEHOLDER_STATE = 'Select a state of residence';
export const NO_OPTIONS_FOUND = 'No options found';

export const KEY_BACKSPACE = 'Backspace';
export const KEY_ESCAPE = 'Escape';
export const EVENT_KEYDOWN = 'keydown';

export const COUNTRY_CODE_CA = 'CA';
